export default function DecimalFormat() {}